import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Alert, Button, Container, Row, Col, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { couponActions, planActions } from '../../actions';
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next';

import PageTitle from "../../components/common/PageTitle";
import moment from 'moment-jalaali'
import DatePicker from 'react-datepicker2';
import date from '../../utils/date'

const CouponsList = () => {
    const { SearchBar } = Search;
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isGregorian = true;
    // const user = useSelector(state => state.authentication.user);
    const loading = useSelector(state => state.coupon.status);
    const coupons = useSelector(state => state.coupon.couponList);
    const plans = useSelector(state => state.plan.plans);
    const plansLoading = useSelector(state => state.plan.loading);
    const [show, setShow] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState();
    const [redeemBy, setRedeemBy] = useState();
    const amountOffRef = useRef()
    const percentOffRef = useRef()
    const planAmountRef = useRef()
    const currencyRef = useRef()
    const selectedPlanRef = useRef()



    useEffect(() => {
        dispatch(planActions.getAll());
        dispatch(couponActions.findAll());
    }, [dispatch])

    const plansDetails = useMemo(() => {
        let plansList = {}
        const sortedPlans = _.sortBy(plans || [], ['interval', 'intervalCount']);
        sortedPlans.forEach(plan => {
            if (plan.amount) {
                const intervalNumber = plan.interval === 'day' ? 1 : (plan.interval === 'month' ? 2 : 3)
                const intervalCount = plan.intervalCount > 9 ? plan.intervalCount : `0${plan.intervalCount}`
                plansList = {
                    ...plansList,
                    [plan._id]: {
                        key: parseInt(`${intervalNumber}${intervalCount}`),
                        name: `${plan.intervalCount} ${_.capitalize(plan.interval)}`,
                        id: plan._id,
                        currency: plan.currency,
                        intervalCount: plan.intervalCount,
                        amount: plan.amount,
                        interval: plan.interval
                    }
                }
            }
        })
        return plansList;
    }, [plans])


    useEffect(() => {
        if (_.has(percentOffRef, 'current.value'))
            percentOffRef.current.value = 0
        if (_.has(selectedPlan, 'amount')) {
            amountOffRef.current.value = 0
            planAmountRef.current.value = _.get(selectedPlanRef, 'current.value') === 'all' ? 'All Plans' : `${_.get(selectedPlan, 'amount', '--')} ${_.get(selectedPlan, 'currency')}`
        }
    }, [selectedPlan])

    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => {
        setShow(true);
    }

    const formik = useFormik({
        initialValues: {
            name: '',
            code: '',
            valid: true,
            duration: 'once',
            durationInMonths: 0,
            maxRedemptions: 0,
            redeemBy: ''
        },
        onSubmit: values => {
            const redeemByDate = redeemBy ? moment(redeemBy).toISOString() : '';
            const planCurrency = _.get(currencyRef, 'current.value', selectedPlan && selectedPlan.currency)
            const coupon = {
                ...values,
                percentOff: percentOffRef.current.value,
                plan: selectedPlanRef.current.value,
                currency: planCurrency,
                redeemBy: redeemByDate,
            }
            //console.log('Create Coupon 1', coupon);
            if (!coupon.plan || coupon.plan === 'all') delete coupon.plan
            if (coupon.durationInMonths !== 0 && !coupon.durationInMonths) delete coupon.durationInMonths
            if (!coupon.maxRedemptions) delete coupon.maxRedemptions
            if (!coupon.redeemBy) delete coupon.redeemBy
            // console.log('Create Coupon 2', coupon);
            setShow(false);
            dispatch(couponActions.create(coupon),);
            // formik.values.name = '';
        },

    });

    const columns = [
        {
            text: 'Name',
            dataField: 'name',
        },
        {
            text: 'Code',
            dataField: 'code',
        },
        {
            text: 'Validation',
            dataField: 'valid',
            formatter: cell => cell ? 'Valid' : <span className="danger">Invalid</span>,
        },
        {
            text: 'Off',
            dataField: 'percentOff',
            formatter: cell => `${cell}%`,
        },
        {
            text: 'Duration',
            dataField: 'duration',
        },
        {
            text: 'Plan',
            dataField: 'plan',
            formatter: (cell, row) => cell ? `${_.get(plansDetails, [cell, 'name'], 'Plan unavailable')} / ${row.currency}` : `All / ${row.currency}`,
        },
        {
            text: 'Redeemed',
            dataField: 'timesRedeemed',
            formatter: redeemedFormatter,
        },
        {
            text: 'Exp. Date',
            dataField: 'redeemBy',
            formatter: cell => cell ? date(cell) : '∞',
        },
        {
            text: 'Last Update',
            dataField: 'updatedAt',
            formatter: cell => date(cell),
        },
        // {
        //     text: 'Action',
        //     dataField: '_id',
        //     formatter: actionFormatter,
        // }
    ]

    function redeemedFormatter(cell, row) {
        const max = row.maxRedemptions ? row.maxRedemptions : '∞'
        return `${cell}/${max}`
    }
    function dateFormatter(cell, row) {
        return date(cell)
    }
    function actionFormatter(cell, row) {
        return (
            <div className="tableTempActionBox">
                <Button className="tableTempAction" theme="info" onClick={() => detailsHandler(cell)}><i className="material-icons">info</i> Details</Button>
                {/* <Button className="tableTempAction" onClick={() => editHandler(cell)}><i className="material-icons">edit</i> Edit</Button>
                <Button className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button> */}
            </div>
        )
    }

    const detailsHandler = (referralId) => {
        // history.push(`referral/${referralId}`);
        setShow(true)
    }

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
        onSizePerPageChange: (sizePerPage, page) => {
        },
        onPageChange: (page, sizePerPage) => {
        }
    };

    function customTotal(from, to, size) {
        return (
            <span className="react-bootstrap-table-pagination-total">
                Showing {from} to {to} of {size} Results
            </span>
        );
    }

    const planHandleChange = (e) => {
        const plan = plansDetails[e.currentTarget.value];
        setSelectedPlan(plan)
    }

    const offHandler = (e) => {
        if (!_.get(selectedPlanRef, 'current.value') || _.get(selectedPlanRef, 'current.value') === 'all' || _.get(selectedPlanRef, 'current.value') === '--') return;
        if (e.currentTarget.name === 'percentOff') amountOffRef.current.value = (selectedPlan.amount * e.currentTarget.value / 100).toFixed(2)
        else percentOffRef.current.value = (e.currentTarget.value * 100 / selectedPlan.amount).toFixed(2)
    }

    return (
        <Container fluid className={`main-content-container px-4 ${loading === 'loading' ? 'blur' : ''}`}>
            {/* Page Header */}
            <Row noGutters className="page-header py-4">
                <PageTitle sm="4" title="Coupons" subtitle="Accounting" className="text-sm-left" />
                <Col className="headerButtonHolder">
                    <Button variant="success" onClick={handleShow}><i className="material-icons"></i> New</Button>
                    {/* <Button className="" variant="danger" onClick={() => history.push(`/referrals`)}><i className="material-icons"></i> Back</Button> */}
                </Col>
            </Row>
            {!plansLoading && Object.keys(plansDetails).length === 0 && (
                <Alert variant="info">
                    No paid plans are available yet. You can create a coupon for All Plans, or add a paid plan in Accounting / Plans first.
                </Alert>
            )}
            <Row>
                <Col>
                    <ToolkitProvider
                        keyField="_id"
                        data={coupons ? [...coupons].reverse() : []}
                        columns={columns}
                        search
                    >
                        {
                            props => (
                                <div>
                                    <SearchBar {...props.searchProps} />
                                    <hr />
                                    <BootstrapTable
                                        {...props.baseProps}
                                        pagination={paginationFactory(options)}
                                    />
                                </div>
                            )
                        }
                    </ToolkitProvider>
                </Col>
            </Row>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>New Coupon</Modal.Title>
                </Modal.Header>
                <form id="form" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <span>Name:</span>
                                <input required id="name" name="name" value={formik.values.name} onChange={formik.handleChange} />
                            </Col>
                            <Col>
                                <span>Code:</span>
                                <input required id="code" name="code" value={formik.values.code} onChange={formik.handleChange} />
                            </Col>
                            <Col>
                                <span>Validation:</span>
                                <select required id="valid" name="valid" value={formik.values.valid} onChange={formik.handleChange}>
                                    <option value={true}>Valid</option>
                                    <option value={false}>Invalid</option>
                                </select>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span>Plan:</span>
                                <select required ref={selectedPlanRef} id="plan" name="plan" onChange={planHandleChange}>
                                    <option value="" hidden>--</option>
                                    {plansDetails && Object.entries(plansDetails).map(([id, data]) =>
                                        <option key={id} value={id}>{`${data.name} ${data.currency}`}</option>
                                    )}
                                    <option value='all'>All Plans</option>
                                </select>
                            </Col>
                            {_.has(selectedPlan, 'amount') ?
                                <>
                                    <Col>
                                        <span>Plan Amount:</span>
                                        <input ref={planAmountRef} id="planAmount" name="planAmount" disabled />
                                    </Col>
                                    <Col>
                                        <span>Percent Off:</span>
                                        <input required ref={percentOffRef} id="percentOff" name="percentOff" disabled={!selectedPlan} onChange={offHandler} />
                                    </Col>
                                    <Col>
                                        <span>Discount:</span>
                                        <input ref={amountOffRef} id="amountOff" name="amountOff" disabled={!selectedPlan} onChange={offHandler} />
                                    </Col>
                                </>
                                :
                                <>
                                    <Col>
                                        <span>Currency:</span>
                                        <select required ref={currencyRef} id="currency" name="currency">
                                            <option value="" hidden>--</option>
                                            <option value='IRR'>IRR</option>
                                            <option value='EUR'>EUR</option>
                                        </select>
                                    </Col>
                                    <Col>
                                        <span>Percent Off:</span>
                                        <input required ref={percentOffRef} id="percentOff" name="percentOff" onChange={offHandler} />
                                    </Col>
                                </>
                            }
                        </Row>
                        <Row>
                            <Col>
                                <span>Duration:</span>
                                <select id="duration" name="duration" value={formik.values.duration} onChange={formik.handleChange} disabled>
                                    <option value="once">Once</option>
                                    <option value="forever">Forever</option>
                                    <option value="repeating">Repeating</option>
                                </select>
                            </Col>
                            <Col>
                                <span>Duration In Months:</span>
                                <input type="number" id="durationInMonths" name="durationInMonths" disabled={formik.values.duration !== 'repeating'} value={formik.values.durationInMonths} onChange={formik.handleChange} />
                            </Col>
                            <Col>
                                <span>Max Redemptions:</span>
                                <input type="number" id="maxRedemptions" name="maxRedemptions" value={formik.values.maxRedemptions} onChange={formik.handleChange} />
                            </Col>
                            <Col>
                                <span>Exp. Date:</span>
                                {/* <input id="redeemBy" name="redeemBy" value={formik.values.redeemBy} onChange={formik.handleChange} /> */}
                                <div style={{ position: 'relative' }}>
                                    <DatePicker
                                        id="redeemBy"
                                        name="redeemBy"
                                        timePicker={false}
                                        onChange={value => setRedeemBy(value)}
                                        value={redeemBy}
                                        min={moment().subtract(1, 'days')}
                                        setTodayOnBlur={false}
                                        isGregorian={isGregorian}
                                        inputFormat="YYYY/MM/DD"
                                        inputJalaaliFormat="jYYYY/jMM/jDD"
                                    />
                                    <Button
                                        className="inputResetBtn"
                                        variant="danger"
                                        hidden={!redeemBy}
                                        onClick={() => setRedeemBy(null)}>X</Button>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleClose}>
                            Cancel
          </Button>
                        <Button type="submit" variant="primary">
                            Create
          </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </Container>
    );
}

export default CouponsList;
